// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuItem_menuItem__ufGVD","active":"MenuItem_active__Gvv+X","icon":"MenuItem_icon__sI2ND","text":"MenuItem_text__Bmxtr"};